"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.typed.uint8-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.regexp.match");

var _title_widget = _interopRequireDefault(require("@/views/widgets/title_widget.vue"));

var _apolloClient = require("@/apollo/apolloClient");

var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));

var _companyMutation = require("@/apollo/mutations/company-mutation");

var _auth = require("@/utils/auth");

var _auth2 = require("../../utils/auth");

var _user = require("@/api/user");

var _v = _interopRequireDefault(require("uuid/v4"));

var _checkExt = require("../../utils/check-ext");

var _validate = require("@/utils/validate");

var _AffiliationGroup = _interopRequireDefault(require("./components/AffiliationGroup"));

var _vueAvatarCropper = _interopRequireDefault(require("vue-avatar-cropper"));

var _firebase = require("firebase");

var _constants = require("@/utils/constants");

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    AffiliationGroup: _AffiliationGroup.default,
    AvatarCropper: _vueAvatarCropper.default,
    TitleWidget: _title_widget.default,
    Button: _button_widget.default
  },
  mixins: [_FirebaseStorageUtil.default],
  data: function data() {
    var _this = this;

    var validateRequire = function validateRequire(rule, value, callback) {
      if (!value) {
        callback(error(rule.colname + 'を入力してください'));
      } else {
        callback();
      }
    };

    var validateRequireOption = function validateRequireOption(rule, value, callback) {
      if (value === '') {
        callback(error(rule.colname + 'を選択してください'));
      } else {
        callback();
      }
    };

    var checkHanEisuCurrentPassword = function checkHanEisuCurrentPassword(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }

      _this.error_current_password = '';

      if (!value) {
        callback(error(rule.colname + 'を入力してください。'));
        return;
      } else if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角を入力してください。'));
      }

      callback();
    };

    var checkHanEisu = function checkHanEisu(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }

      if (!value) {
        callback(error(rule.colname + 'を入力してください。'));
        return;
      } else if (_this.isHanEisu(value) === false) {
        callback(error(rule.colname + 'は半角を入力してください。'));
      } else {
        if (value.length > 0) {
          if (value.length < rule.minLen) {
            callback(error('半角英数字' + rule.minLen + '桁以上を入力してください。'));
          }
        }

        callback();
      }
    };

    var checkHanEisuEx = function checkHanEisuEx(rule, value, callback) {
      if (_this.pass_check === false) {
        callback();
        return;
      }

      if (_this.$data.form.password !== _this.$data.password_org) {
        if (_this.$data.form.password !== value) {
          callback(error('社員パスワードと社員パスワード（確認用）が異なります。'));
          return;
        }
      }

      callback();
    };

    var validateRequireEmployee = function validateRequireEmployee(rule, value, callback) {
      callback();
    };

    var error = function error(message) {
      return new Error(message);
    };

    return {
      loading_delete: false,
      mark_description: '',
      description: {
        description_admin: '<div style="line-height: 1.8">チェックをONにすると「役割：一般」のユーザーからメッセージやアプリ内通話などの受信が受けられなくなります。</br>※すでにやりとりをした事があるユーザーからの連絡を受けることは可能です。</div>',
        description_staff: '<div style="line-height: 1.8">・チェックをONにすると「役割：一般」同士と連絡ができなくなります。</br>・チェックをOFFにすると「役割：一般」同士の公開ユーザーと連絡をすることが可能です。</div>'
      },
      datePickerOptions: {
        disabledDate: function disabledDate(date) {
          return date > new Date();
        }
      },
      showGoBackButton: false,
      role: {},
      buttonStatusUpdate: {
        deepOn: false,
        disableUpdateButton: true
      },
      dataCropper: {
        fileName: '',
        triggerCropImage: false
      },
      keyAffiliation: 0,
      title: '',
      drawer: false,
      pathAffiliationList: [],
      createdAffiliation: '',
      pass_check: false,
      error_current_password: '',
      disable_password: true,
      disable_industries: true,
      company_id: null,
      fileAvatar: [],
      // アバター
      fileAvatarOrg: '',
      phone_number: '',
      password_org: '',
      upload_fax: '',
      upload_mobile: '',
      upload_postcode: '',
      majorName: '',
      space: '　',
      form: {
        employee_id: '',
        history_employee_id: '',
        uid: '',
        company_id: '',
        avatar: '',
        // 社員写真
        last_name: '',
        // 社員名（姓）
        last_name_furigana: '',
        // 社員名（ふりがな姓）
        name: '',
        // 社員名（名）
        name_furigana: '',
        // 社員名（ふりがな名）
        position: '',
        // 役職名
        others: '',
        // その他
        mobile_phone: '',
        // 携帯番号
        id: '',
        // ログインID
        current_password: '',
        current_password_server: '',
        password: '',
        // ログインパスワード
        confirmation_password: '',
        is_display: true,
        // アプリへの社員表示の有無
        is_active: true,
        // 社員の管理
        is_active_history: null,
        company: {
          id: '',
          // 会社ID
          website: '',
          // ホームページ
          business_descriptions: '',
          // 事業内容
          capital_stock: '',
          // 資本金
          email: '',
          // E-mail
          employees: '',
          // 社員数
          employees_part_time: '',
          // パート数
          established: '',
          // 会社創立年月日
          fax1: '',
          // 会社FAX
          fax2: '',
          // 会社FAX
          fax3: '',
          // 会社FAX
          name: '',
          // 社員企業名
          name_furigana: '',
          // 社員企業名（ふりがな）
          address_1: '',
          // 会社住所
          address_2: '',
          // ビル名
          phone_number1: '',
          // 会社TEL
          phone_number2: '',
          // 会社TEL
          phone_number3: '',
          // 会社TEL
          join_date: '',
          // 入社年月
          industry: '',
          // 職種コード
          mobile_phone1: '',
          // 携帯番号
          mobile_phone2: '',
          // 携帯番号
          mobile_phone3: '',
          // 携帯番号
          postcode1: '',
          // 会社郵便番号
          postcode2: '',
          // 会社郵便番号
          industries: {
            id: '',
            // 職種ID
            name: '',
            // 職種
            group_id: '',
            // グループID
            code: ''
          },
          created_at: '' // 作成日時

        },
        show_company_info: '',
        personal_contact_authority: '',
        user_type: ''
      },
      waitDialogVisible: false,
      updateDialogVisible: false,
      period: [{
        scope: ''
      }],
      textOrganization: '',
      textOrganizationShibu: '',
      textOrganizationChiku: '',
      errorMessageOrganization: '',
      props: [],
      defaultCheckedProps: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      role_permission: {
        textShowCheckBox: '',
        enablePrivateChat: false,
        showWindow: false,
        roleCheckedId: null
      },
      checkNumber: function checkNumber(rule, value, callback) {
        if (value === null) {
          callback();
          return;
        }

        if (_this.isNumber(value) === false && value.length > 0) {
          callback(error(rule.colname + 'は半角数字で入力してください'));
        } else {
          callback();
        }
      },
      validateRequire: function validateRequire(rule, value, callback) {
        if (!_this.form.company.postcode1 && !_this.form.company.postcode2) {
          _this.$data.upload_postcode = (0, _v.default)();
          callback();
          return;
        }

        callback();
      },
      validateRequireEmployee: function validateRequireEmployee(rule, value, callback) {
        callback();
      },
      validateRequirePhone: function validateRequirePhone(rule, value, callback) {
        if (!_this.form.company.phone_number1 && !_this.form.company.phone_number2 && !_this.form.company.phone_number3) {
          _this.$data.upload_mobile = (0, _v.default)();
          callback();
          return;
        } else if (_this.form.company.phone_number1 || _this.form.company.phone_number2 || _this.form.company.phone_number3) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
            return;
          } else if (_this.isNumber(value) === false) {
            callback(error(rule.colname + 'は、半角数字で入力してください'));
            return;
          }
        }

        callback();
      },
      tel1: function tel1(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }

        callback();
      },
      tel2: function tel2(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }

        callback();
      },
      tel3: function tel3(rule, value, callback) {
        if (value.length > 5) {
          callback(error(rule.colname + '桁数は５桁以内で入力してください'));
          return;
        }

        callback();
      },
      postcode1: function postcode1(rule, value, callback) {
        if (_this.form.company.postcode1 || _this.form.company.postcode2) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
          } else if (_this.isNumber(value) === false) {
            callback(error('郵便番号は、半角数字で入力してください'));
            return;
          } else if (value.length !== 3) {
            callback(error(rule.colname + '桁数は３桁で入力してください'));
            return;
          }
        }

        callback();
      },
      postcode2: function postcode2(rule, value, callback) {
        if (_this.form.company.postcode1 || _this.form.company.postcode2) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
          } else if (_this.isNumber(value) === false) {
            callback(error('郵便番号は、半角数字で入力してください'));
            return;
          } else if (value.length !== 4) {
            callback(error(rule.colname + '桁数は4桁で入力してください'));
            return;
          }
        }

        callback();
      },
      validateRequireFax: function validateRequireFax(rule, value, callback) {
        if (_this.$data.form.company.fax1.length === 0 && _this.$data.form.company.fax2.length === 0 && _this.$data.form.company.fax3.length === 0) {
          _this.$data.upload_fax = (0, _v.default)();
          callback();
          return;
        } else if (_this.$data.form.company.fax1 || _this.$data.form.company.fax2 || _this.$data.form.company.fax3) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください。'));
            return;
          } else if (_this.isNumber(value) === false) {
            callback(error(rule.colname + 'は、半角数字で入力してください。'));
            return;
          }
        }

        callback();
      },
      validateRequireMobile: function validateRequireMobile(rule, value, callback) {
        if (_this.$data.form.company.mobile_phone1.length === 0 && _this.$data.form.company.mobile_phone2.length === 0 && _this.$data.form.company.mobile_phone3.length === 0) {
          _this.$data.upload_mobile = (0, _v.default)();
          callback();
          return;
        }

        if (_this.$data.form.company.mobile_phone1 || _this.$data.form.company.mobile_phone2 || _this.$data.form.company.mobile_phone3) {
          if (!value) {
            callback(error(rule.colname + 'を入力してください'));
            return;
          } else if (_this.isNumber(value) === false) {
            callback(error(rule.colname + 'は、半角数字で入力してください'));
            return;
          }
        }

        callback();
      },
      checkDate: function checkDate(rule, value, callback) {
        if (value === '' || value === null) {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      validateRequireOption: function validateRequireOption(rule, value, callback) {
        if (value === '') {
          callback(error(rule.colname + 'を選択してください'));
        } else {
          callback();
        }
      },
      email: function email(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
          return;
        }

        if (!value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }

        callback();
      },
      url: function url(rule, value, callback) {
        if (value === '' || value === null || value === undefined) {
          callback();
          return;
        }

        if (!value.match(/(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/)) {
          callback(error(rule.colname + 'が正しくありません。'));
          return;
        }

        callback();
      },
      rules: {
        last_name: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（姓）'
        }],
        name: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（名）'
        }],
        last_name_furigana: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（ふりがな姓）'
        }],
        name_furigana: [{
          required: true,
          validator: validateRequire,
          colname: '社員名（ふりがな名）'
        }],
        current_password: [{
          required: true,
          validator: checkHanEisuCurrentPassword,
          colname: '現在パスワード',
          minLen: 4,
          maxLen: null
        }],
        password: [{
          required: true,
          validator: checkHanEisu,
          colname: '社員パスワード',
          minLen: 4,
          maxLen: null
        }],
        confirmation_password: [{
          required: true,
          validator: checkHanEisuEx,
          colname: '社員パスワード（確認用）',
          minLen: 4,
          maxLen: null
        }],
        is_display: [{
          required: true,
          validator: validateRequireOption,
          colname: 'アプリへの社員表示の有無'
        }],
        show_company_info: [{
          required: true,
          validator: validateRequireOption,
          colname: 'アプリへのプロフィール情報'
        }],
        is_active: [{
          required: true,
          validator: validateRequireOption,
          colname: '社員の管理'
        }],
        user_type: [{
          required: true,
          validator: validateRequireOption,
          colname: 'ユーザーの役割'
        }],
        employee_id: [{
          required: false,
          validator: validateRequireEmployee,
          colname: '社員番号'
        }]
      }
    };
  },
  computed: {
    coms: function coms() {
      return this.$store.getters.companies;
    },
    industry_major: function industry_major() {
      return this.$store.getters.industryMajorOptions;
    },
    industry_middle: function industry_middle() {
      return this.$store.getters.industryMiddleOptions;
    },
    industry_info: function industry_info() {
      return this.$store.getters.industryInfo;
    },
    displays: function displays() {
      return this.$store.getters.displayOptions;
    },
    logins: function logins() {
      return this.$store.getters.loginOptions;
    },
    company: function company() {
      return this.$store.getters.company;
    },
    detail: function detail() {
      return this.$store.companyDetail;
    },
    userRoles: function userRoles() {
      return this.$store.getters.userRoles;
    },
    roleDefault: function roleDefault() {
      return this.$store.getters.roleDefault;
    },
    roleById: function roleById() {
      return this.$store.getters.userRoleByIdList;
    }
  },
  watch: {
    $data: {
      deep: true,
      handler: function handler(value) {
        this.listeningStatusUpdateButton(value);
      }
    }
  },
  created: function created() {},
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var roleType, uid, user, postcodes, phone_numbers, fax_numbers, mobile_phones;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _auth.getUserPermission)();

            case 2:
              roleType = _context.sent;

              if (roleType) {
                this.role = JSON.parse(roleType);
              }

              uid = this.$route.params.uid;

              if (!uid) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return (0, _auth2.setIdEditPage)(uid);

            case 8:
              _context.t0 = (0, _auth2.getGoFromPage)();
              _context.next = _context.t0 === 'Company' ? 11 : 13;
              break;

            case 11:
              this.showGoBackButton = true;
              return _context.abrupt("break", 13);

            case 13:
              _context.next = 15;
              return this.$store.dispatch('company/clear');

            case 15:
              _context.next = 17;
              return this.$store.dispatch('company/getDisplayList');

            case 17:
              _context.next = 19;
              return this.$store.commit('company/setOptionValue', null);

            case 19:
              _context.next = 21;
              return this.$store.dispatch('company/getLoginList');

            case 21:
              _context.next = 23;
              return this.$store.dispatch('company/getIndustryMajorList');

            case 23:
              _context.next = 25;
              return this.$store.commit('company/pathToListItem', []);

            case 25:
              _context.next = 27;
              return this.$store.dispatch('company/getRoles');

            case 27:
              _context.next = 29;
              return this.$store.dispatch('company/fetchAffiliation');

            case 29:
              _context.next = 31;
              return this.$store.dispatch('company/fetchCompany', {
                uid: (0, _auth2.getIdEditPage)()
              });

            case 31:
              _context.next = 33;
              return this.$store.commit('company/setEnableTextAllSelect', false);

            case 33:
              _context.next = 35;
              return this.$store.dispatch('company/fetchAffiliation');

            case 35:
              _context.next = 37;
              return this.$store.dispatch('company/GET_ROLE_DEFAULT');

            case 37:
              user = this.$store.getters.member;

              if (user) {
                _context.next = 40;
                break;
              }

              return _context.abrupt("return");

            case 40:
              this.getTreeProps(user.user_affiliations);
              _context.next = 43;
              return this.$store.dispatch('company/getRoleById', user.role_id);

            case 43:
              // / user
              if (user.avatar) {
                this.$data.fileAvatarOrg = user.avatar;
              }

              if (user.uid) {
                this.form.uid = user.uid;
              }

              if (user.avatar) {
                this.$data.form.avatar = user.avatar; // 社員写真
              }

              if (user.last_name) {
                this.$data.form.last_name = user.last_name; // 社員名（姓）
              }

              if (user.last_name_furigana) {
                this.$data.form.last_name_furigana = user.last_name_furigana; // 社員名（ふりがな姓）
              }

              if (user.name) {
                this.$data.form.name = user.name; // 社員名（名）
              }

              if (user.name_furigana) {
                this.$data.form.name_furigana = user.name_furigana; // 社員名（ふりがな名）
              }

              if (user.position) {
                this.$data.form.position = user.position; // 役職名
              }

              if (user.employee_id) {
                this.$data.form.employee_id = user.employee_id;
                this.$data.form.history_employee_id = user.employee_id;
              }

              if (user.others) {
                this.$data.form.others = user.others;
              }

              if (user.mobile_phone) {
                this.$data.form.mobile_phone = user.mobile_phone; // 携帯番号
              }

              if (user.id) {
                this.$data.form.id = user.id; // ログインID
              }

              if (user.password) {
                this.$data.form.current_password_server = user.password; // ログインパスワード
              }

              this.$data.form.is_display = user.is_display; // アプリへの社員表示の有無

              this.$data.form.is_active = user.is_active; // 社員の管理

              this.$data.form.is_active_history = user.is_active;
              this.form.user_type = user.role_id;
              this.onChangePermission(user.role_id);

              if (user.user_policy && user.user_policy.length) {
                this.role_permission.enablePrivateChat = user.user_policy[0].is_active;
                this.role_permission.roleCheckedId = user.role_id;
              }

              if (!user.user_policy || !user.user_policy.length) {
                if (this.roleById) {
                  this.role_permission.enablePrivateChat = !this.roleById.app_private_chat_create;
                }
              } // / company


              if (user.company) {
                _context.next = 65;
                break;
              }

              return _context.abrupt("return");

            case 65:
              this.$data.form.company_id = user.company_id;
              this.$data.form.show_company_info = user.show_company_info;
              this.$data.form.company.id = user.company.id; // 会社ID

              if (user.company.capital_stock) {
                this.$data.form.company.capital_stock = user.company.capital_stock; // 資本金
              }

              if (user.company.employees) {
                this.$data.form.company.employees = user.company.employees; // 社員数
              }

              if (user.company.employees_part_time) {
                this.$data.form.company.employees_part_time = user.company.employees_part_time; // パート
              }

              if (user.company.established) {
                this.$data.form.company.established = user.company.established; // 会社創立年月日
              }

              if (user.company.name) {
                this.$data.form.company.name = user.company.name; // 社員企業名
              }

              if (user.company.name_furigana) {
                this.$data.form.company.name_furigana = user.company.name_furigana; // 社員企業名（ふりがな）
              }

              if (user.company.address_1) {
                this.$data.form.company.address_1 = user.company.address_1; // 会社住所
              }

              if (user.company.address_2) {
                this.$data.form.company.address_2 = user.company.address_2; // ビル名
              }

              if (user.company.join_date) {
                this.$data.form.company.join_date = user.company.join_date; // 入社年月
              }

              if (user.company.business_descriptions) {
                this.$data.form.company.business_descriptions = user.company.business_descriptions; // 事業内容
              }

              if (user.company.postcode) {
                postcodes = user.company.postcode.split('-');

                if (postcodes.length > 0) {
                  this.$data.form.company.postcode1 = postcodes[0];
                }

                if (postcodes.length > 1) {
                  this.$data.form.company.postcode2 = postcodes[1];
                }
              } // / phone number


              if (user.company.phone_number) {
                phone_numbers = user.company.phone_number.split('-');

                if (phone_numbers.length > 0) {
                  this.$data.form.company.phone_number1 = phone_numbers[0];
                }

                if (phone_numbers.length > 1) {
                  this.$data.form.company.phone_number2 = phone_numbers[1];
                }

                if (phone_numbers.length > 2) {
                  this.$data.form.company.phone_number3 = phone_numbers[2];
                }
              } // / fax


              if (user.company.fax) {
                fax_numbers = user.company.fax.split('-');

                if (fax_numbers.length > 0) {
                  this.$data.form.company.fax1 = fax_numbers[0];
                }

                if (fax_numbers.length > 1) {
                  this.$data.form.company.fax2 = fax_numbers[1];
                }

                if (fax_numbers.length > 2) {
                  this.$data.form.company.fax3 = fax_numbers[2];
                }
              }

              if (user.company.mobile_phone) {
                mobile_phones = user.company.mobile_phone.split('-');

                if (mobile_phones.length > 0) {
                  this.$data.form.company.mobile_phone1 = mobile_phones[0];
                }

                if (mobile_phones.length > 1) {
                  this.$data.form.company.mobile_phone2 = mobile_phones[1];
                }

                if (mobile_phones.length > 2) {
                  this.$data.form.company.mobile_phone3 = mobile_phones[2];
                }
              } // website


              if (user.company.website) {
                this.$data.form.company.website = user.company.website;
              }

              if (user.company.email) {
                this.$data.form.company.email = user.company.email;
              }

              this.buttonStatusUpdate.deepOn = true;
              (0, _auth2.setHistoryDataFromPage)(JSON.stringify(this.$data));

            case 86:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    handleDeleteItem: function () {
      var _handleDeleteItem = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var result, deleteItem;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _constants.message_box_confirm)('確認', '削除を行うとアカウントを復元する事は出来ません。削除アカウントは強制ログアウトされます。よろしいですか？', '削除', 'message_delete');

              case 2:
                result = _context2.sent;

                if (!result) {
                  _context2.next = 10;
                  break;
                }

                this.loading_delete = true;
                _context2.next = 7;
                return this.$store.dispatch('company/DELETE_EMPLOYEES_BY_DELETED_AT_MUTATION', this.$data.form.uid).catch(function (error) {
                  console.log(error);

                  _this2.$notify({
                    title: 'エラー',
                    message: '削除に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });
                });

              case 7:
                deleteItem = _context2.sent;

                if (deleteItem) {
                  this.$notify({
                    title: '情報',
                    message: '削除に成功しました。',
                    type: 'success',
                    duration: 2000
                  });
                  this.$router.replace({
                    name: 'CompanyIndex'
                  });
                }

                this.loading_delete = false;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleDeleteItem() {
        return _handleDeleteItem.apply(this, arguments);
      }

      return handleDeleteItem;
    }(),
    onChangePermission: function onChangePermission(roleId) {
      var userRole = this.userRoles;
      this.role_permission.enablePrivateChat = false;

      if (this.role_permission.roleCheckedId) {
        if (this.role_permission.roleCheckedId === roleId) {
          this.role_permission.enablePrivateChat = true;
        }
      }

      if (!userRole || !userRole.length) {
        return;
      }

      var role = userRole.filter(function (item) {
        return item.id === roleId;
      });

      if (role.length) {
        var isRoleBlock = userRole.filter(function (item) {
          return item.is_default_role;
        });

        if (role[0].allow_ignore_blocking_chat) {
          this.role_permission.textShowCheckBox = "\u300C".concat(isRoleBlock[0].name, "\u300D\u30E6\u30FC\u30B6\u30FC\u304B\u3089\u306E\u9023\u7D61\u3092\u53D7\u4FE1\u3057\u306A\u3044");
          this.mark_description = this.description.description_admin;
        } else {
          this.role_permission.textShowCheckBox = "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30E6\u30FC\u30B6\u30FC\u306B\u3059\u308B";
          this.mark_description = this.description.description_staff;
        }

        this.role_permission.showWindow = role[0].allow_extend_role;
      }
    },
    getTreeProps: function getTreeProps(user_affiliations) {
      var listData = [];
      var affiliationList = [];

      function createDataByElTree(input) {
        var treeMode = {
          id: input.id,
          label: input.name,
          children: input.affiliations.map(function (subItem) {
            return createDataByElTree(subItem);
          })
        };

        if (user_affiliations && user_affiliations.length) {
          var findAffiliation = user_affiliations.some(function (item) {
            return item.affiliation_id === input.id;
          });

          if (findAffiliation) {
            affiliationList.push(treeMode);
          }
        }

        return treeMode;
      }

      listData = this.$store.getters.affiliations.map(function (item) {
        return createDataByElTree(item);
      });
      this.props = listData;

      if (user_affiliations && user_affiliations.length) {
        this.defaultCheckedProps = user_affiliations.map(function (item) {
          return item.affiliation.id;
        });
      }

      this.pathAffiliationList = (0, _toConsumableArray2.default)(new Set(affiliationList));
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        if (!this.pathAffiliationList || !this.pathAffiliationList.length) {
          this.pathAffiliationList.push(data);
        } else {
          var findAffiliation = this.pathAffiliationList.some(function (item) {
            return item.id !== data.id;
          });

          if (findAffiliation) {
            this.pathAffiliationList.push(data);
          }
        }
      } else {
        this.pathAffiliationList.splice(this.pathAffiliationList.indexOf(data), 1);
      }
    },
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'CompanyIndex'
      });
    },
    listeningStatusUpdateButton: function () {
      var _listeningStatusUpdateButton = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(value) {
        var isHistory, isChanged, replace;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.buttonStatusUpdate.deepOn) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.next = 4;
                return (0, _auth2.getHistoryDataFromPage)();

              case 4:
                isHistory = _context3.sent;
                isChanged = JSON.stringify(value);
                replace = isChanged.replace('disableUpdateButton":false', 'disableUpdateButton":true');

                if (isHistory !== replace) {
                  this.buttonStatusUpdate.disableUpdateButton = false;
                } else {
                  this.buttonStatusUpdate.disableUpdateButton = true;
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listeningStatusUpdateButton(_x) {
        return _listeningStatusUpdateButton.apply(this, arguments);
      }

      return listeningStatusUpdateButton;
    }(),
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mime
      });
    },
    cropperHandler: function cropperHandler(cropper) {
      var getDataCanvas = cropper.getCroppedCanvas().toDataURL();
      this.fileAvatarOrg = getDataCanvas;
      var file = this.dataURLtoFile(getDataCanvas, this.dataCropper.fileName);
      this.fileAvatar = [file];
    },
    handleUploading: function handleUploading(file, reader) {
      this.dataCropper.fileName = file.file.name;
    },
    handlerError: function handlerError(message, type, xhr) {
      this.$notify({
        title: 'エラー',
        message: '対応していないファイル形式です',
        type: 'error',
        duration: 2000
      });
    },
    deleteItemAffiliation: function deleteItemAffiliation(item, index) {
      var indexSplice = 1;

      for (var i = index + 1; i < this.pathAffiliationList.length; i++) {
        if (this.pathAffiliationList[i].paddingFloorInTreeAffiliation > item.paddingFloorInTreeAffiliation) {
          indexSplice = indexSplice + 1;
        } else break;
      }

      this.pathAffiliationList.splice(index, indexSplice);
    },
    swapAffiliationComponent: function () {
      var _swapAffiliationComponent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(data) {
        var _this3 = this;

        var listPathOriginalAffiliation, pathFromDepth, setAffiliation;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.drawer = !this.drawer;
                if (this.drawer) this.$store.commit('company/pathToListItem', []);else this.keyAffiliation++;
                listPathOriginalAffiliation = this.$store.getters.pathToListItem;

                if (!(listPathOriginalAffiliation.length !== 0 && listPathOriginalAffiliation && this.drawer === false)) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 6;
                return (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, listPathOriginalAffiliation);

              case 6:
                pathFromDepth = _context4.sent;

                if (this.pathAffiliationList.length !== 0) {
                  setAffiliation = pathFromDepth.filter(function (val) {
                    return _this3.pathAffiliationList.some(function (entire) {
                      return val.id === entire.id;
                    }) === false;
                  });

                  if (setAffiliation.length !== 0) {
                    setAffiliation.forEach(function (item) {
                      return _this3.pathAffiliationList.push(item);
                    });
                  }
                } else this.pathAffiliationList = pathFromDepth;

                this.pathAffiliationList.sort(function (a, b) {
                  return a.idFake - b.idFake;
                }); // / 所属している組織ときに通知を表示または非表示にする

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function swapAffiliationComponent(_x2) {
        return _swapAffiliationComponent.apply(this, arguments);
      }

      return swapAffiliationComponent;
    }(),
    activePwd: function activePwd() {
      this.pass_check = !this.pass_check;

      if (this.pass_check === true) {
        this.disable_password = false;
        this.$data.form.current_password = '';
        this.$data.form.password = '';
        this.$data.form.confirmation_password = '';
      } else {
        this.disable_password = true;
      }
    },
    changeIndustryMajor: function () {
      var _changeIndustryMajor = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$store.dispatch('company/getIndustryMiddleList', {
                  group_id: this.$data.form.company.industries.group_id
                });

              case 2:
                this.$data.form.company.industry = this.$store.getters.industryMiddleOptions[0].code;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function changeIndustryMajor() {
        return _changeIndustryMajor.apply(this, arguments);
      }

      return changeIndustryMajor;
    }(),
    getExtension: function getExtension(fileName) {
      var ret;

      if (!fileName) {
        return ret;
      }

      var fileTypes = fileName.split('.');
      var len = fileTypes.length;

      if (len === 0) {
        return ret;
      }

      ret = fileTypes[len - 1];
      return ret;
    },
    handleRemoveAvatar: function handleRemoveAvatar(file, fileList) {
      this.log('handleRemoveAvatar');
      this.fileAvatar = fileList;
    },
    handleDeleteAvatar: function handleDeleteAvatar(file, fileList) {
      this.log('handleDeleteAvatar');
      this.fileAvatarOrg = '';
    },
    handleAddAvatar: function handleAddAvatar(file, fileList) {
      this.log('handleAddAvatar');

      if ((0, _checkExt.checkExtImage)(file.name)) {
        this.fileAvatar = fileList;
      } else {
        this.fileAvatar = [];
        this.$refs.upload.clearFiles();
        this.$notify({
          title: 'エラー',
          message: '対応していないファイル形式です',
          type: 'error',
          duration: 2000
        });
      }
    },
    handleDialogQuestion: function () {
      var _handleDialogQuestion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(title, content, yes, no) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.$confirm(content, title, {
                  confirmButtonText: yes,
                  cancelButtonText: no,
                  showCancelButton: false,
                  center: true
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function handleDialogQuestion(_x3, _x4, _x5, _x6) {
        return _handleDialogQuestion.apply(this, arguments);
      }

      return handleDialogQuestion;
    }(),
    checkUserPlan: function () {
      var _checkUserPlan = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7() {
        var planData, content;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.form.is_active !== this.form.is_active_history)) {
                  _context7.next = 11;
                  break;
                }

                if (!this.form.is_active) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 4;
                return this.$store.dispatch('company/getPlanUser');

              case 4:
                planData = _context7.sent;

                if (!planData) {
                  _context7.next = 11;
                  break;
                }

                if (!planData.warning_when_reach_max_user) {
                  _context7.next = 11;
                  break;
                }

                if (!(planData.user_count >= planData.max_user)) {
                  _context7.next = 11;
                  break;
                }

                content = "".concat(planData.max_user, "\u540D\u307E\u3067\u9650\u5B9A\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u306E\u3067\u3001\u30ED\u30B0\u30A4\u30F3\u6A29\u9650\u306E\u5909\u66F4\u306F\u3067\u304D\u307E\u305B\u3093\u3002");
                this.handleDialogQuestion('確認', content, 'OK');
                return _context7.abrupt("return", true);

              case 11:
                return _context7.abrupt("return", false);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function checkUserPlan() {
        return _checkUserPlan.apply(this, arguments);
      }

      return checkUserPlan;
    }(),
    postFromCheck: function postFromCheck() {
      var _this4 = this;

      this.log(this.form); // エラーが発生した場合は停止します

      this.$refs['form'].validate(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee8(valid) {
          var questionYesOrNo;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!valid) {
                    _context8.next = 11;
                    break;
                  }

                  _context8.next = 3;
                  return _this4.checkUserPlan();

                case 3:
                  if (!_context8.sent) {
                    _context8.next = 5;
                    break;
                  }

                  return _context8.abrupt("return");

                case 5:
                  _context8.next = 7;
                  return (0, _constants.message_box_confirm)('確認', '情報を更新します。よろしいですか？', '更新', 'message_default');

                case 7:
                  questionYesOrNo = _context8.sent;

                  if (questionYesOrNo) {
                    _this4.onUpdate();
                  }

                  _context8.next = 13;
                  break;

                case 11:
                  _this4.log('error submit!!');

                  return _context8.abrupt("return", false);

                case 13:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x7) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    onUpdate: function () {
      var _onUpdate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee9() {
        var _this5 = this;

        var fileAvatarURL, employees, employees_part_time, established, join_date, objects, hasErrorUpdate, objectsAffilication, listAffiliationId, pathFromDepth, phoneNumber, mobilePhone, fax, postCode, userRole, roleBlock, user_role_chat;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.waitDialogVisible = true;
                this.updateDialogVisible = false; // アバターの保存

                fileAvatarURL = '';

                if (!(this.fileAvatar.length > 0)) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 6;
                return this.uploadFileToStorage(this.fileAvatar[0], 'users/avatar/avatar_' + this.form.uid + '.jpg');

              case 6:
                fileAvatarURL = _context9.sent;

                if (!(fileAvatarURL == null)) {
                  _context9.next = 11;
                  break;
                }

                console.log('画像のアップロードに失敗しました。');
                this.waitDialogVisible = false;
                return _context9.abrupt("return");

              case 11:
                // / 自分のアバターを取る
                if ((0, _firebase.auth)().currentUser && (0, _firebase.auth)().currentUser.uid === this.form.uid) {
                  this.$store.commit('MY_AVATAR_CREATE', fileAvatarURL);
                }

              case 12:
                if (this.fileAvatarOrg) {
                  if (this.fileAvatarOrg && !fileAvatarURL) {
                    // 画像の変更無し
                    fileAvatarURL = this.fileAvatarOrg;
                  }
                }

                employees = null;

                if (this.$data.form.company.employees) {
                  employees = this.$data.form.company.employees;
                }

                employees_part_time = null;

                if (this.$data.form.company.employees_part_time) {
                  employees_part_time = this.$data.form.company.employees_part_time;
                }

                established = null;

                if (this.$data.form.company.established) {
                  established = new Date(this.$data.form.company.established).toLocaleString({
                    timeZone: 'Asia/Tokyo'
                  });
                }

                join_date = null;

                if (this.$data.form.company.join_date) {
                  join_date = new Date(this.$data.form.company.join_date).toLocaleString({
                    timeZone: 'Asia/Tokyo'
                  });
                }

                objects = {};

                if (this.pass_check === true) {
                  objects = {
                    avatar: fileAvatarURL,
                    last_name: this.$data.form.last_name.toString().trim(),
                    last_name_furigana: this.$data.form.last_name_furigana.toString().trim(),
                    name: this.$data.form.name.toString().trim(),
                    name_furigana: this.$data.form.name_furigana.toString().trim(),
                    position: this.$data.form.position,
                    others: this.$data.form.others,
                    mobile_phone: this.$data.form.mobile_phone,
                    password: (0, _user.encrypt)(this.$data.form.password),
                    is_display: this.$data.form.is_display,
                    is_active: this.$data.form.is_active,
                    role_id: this.form.user_type,
                    show_company_info: this.form.show_company_info,
                    employee_id: this.form.employee_id
                  };
                } else {
                  objects = {
                    avatar: fileAvatarURL,
                    last_name: this.$data.form.last_name.toString().trim(),
                    last_name_furigana: this.$data.form.last_name_furigana.toString().trim(),
                    name: this.$data.form.name.toString().trim(),
                    name_furigana: this.$data.form.name_furigana.toString().trim(),
                    position: this.$data.form.position,
                    others: this.$data.form.others,
                    mobile_phone: this.$data.form.mobile_phone,
                    is_display: this.$data.form.is_display,
                    is_active: this.$data.form.is_active,
                    role_id: this.form.user_type,
                    show_company_info: this.form.show_company_info,
                    employee_id: this.form.employee_id
                  };
                }

                hasErrorUpdate = false;
                _context9.next = 26;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.UPDATE_MEMBER,
                  variables: {
                    uid: this.$data.form.uid,
                    objects: objects
                  }
                }).catch(function (error) {
                  _this5.$notify({
                    title: '情報',
                    message: '更新に失敗しました。',
                    type: 'error',
                    duration: 2000
                  });

                  _this5.waitDialogVisible = false;

                  _this5.log(error);

                  hasErrorUpdate = true;
                  return;
                });

              case 26:
                objectsAffilication = [];
                listAffiliationId = [];

                if (this.pathAffiliationList.length !== 0) {
                  pathFromDepth = (0, _validate.depthFirstSearch)(this.$store.getters.affiliations, this.pathAffiliationList);
                  pathFromDepth.map(function (item) {
                    listAffiliationId.push(item.id);
                    objectsAffilication.push({
                      affiliation_id: item.id,
                      user_id: _this5.$data.form.uid,
                      is_directly: Boolean(item.is_directly)
                    });
                  });
                }

                _context9.next = 31;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.USER_AFFILIATION_INSERT_UPDATE,
                  variables: {
                    user_id: this.$data.form.uid,
                    affiliation_ids: listAffiliationId,
                    objects: objectsAffilication
                  }
                }).catch(function (error) {
                  _this5.$notify({
                    title: '情報',
                    message: '組織の更新に失敗しました。',
                    type: 'error',
                    duration: 2000
                  });

                  _this5.waitDialogVisible = false;
                  console.log(error);
                  hasErrorUpdate = true;
                  return;
                });

              case 31:
                //
                phoneNumber = null;

                if (this.$data.form.company.phone_number1 && this.$data.form.company.phone_number2 && this.$data.form.company.phone_number3) {
                  phoneNumber = this.$data.form.company.phone_number1 + '-' + this.$data.form.company.phone_number2 + '-' + this.$data.form.company.phone_number3;
                }

                mobilePhone = null;

                if (this.$data.form.company.mobile_phone1 && this.$data.form.company.mobile_phone2 && this.$data.form.company.mobile_phone3) {
                  mobilePhone = this.$data.form.company.mobile_phone1 + '-' + this.$data.form.company.mobile_phone2 + '-' + this.$data.form.company.mobile_phone3;
                }

                fax = null;

                if (this.$data.form.company.fax1 && this.$data.form.company.fax2 && this.$data.form.company.fax3) {
                  fax = this.$data.form.company.fax1 + '-' + this.$data.form.company.fax2 + '-' + this.$data.form.company.fax3;
                }

                postCode = null;

                if (this.$data.form.company.postcode1 && this.$data.form.company.postcode2) {
                  postCode = this.$data.form.company.postcode1 + '-' + this.$data.form.company.postcode2;
                }

                _context9.next = 41;
                return _apolloClient.apolloClient.mutate({
                  mutation: _companyMutation.UPDATE_COMPANY_ADMIN,
                  variables: {
                    id: this.$data.form.company.id,
                    name: this.$data.form.company.name.toString().trim(),
                    name_furigana: this.$data.form.company.name_furigana.toString().trim(),
                    phone_number: phoneNumber,
                    mobile_phone: mobilePhone,
                    fax: fax,
                    email: this.$data.form.company.email,
                    website: this.$data.form.company.website,
                    postcode: postCode,
                    address_1: this.$data.form.company.address_1,
                    address_2: this.$data.form.company.address_2,
                    business_descriptions: this.$data.form.company.business_descriptions,
                    capital_stock: this.$data.form.company.capital_stock,
                    employees: employees,
                    employees_part_time: employees_part_time,
                    established: established,
                    join_date: join_date
                  }
                }).catch(function (error) {
                  _this5.$notify({
                    title: '情報',
                    message: '更新に失敗しました。',
                    type: 'error',
                    duration: 2000
                  });

                  _this5.waitDialogVisible = false;
                  console.log(error);
                  hasErrorUpdate = true;
                  return;
                });

              case 41:
                if (!(hasErrorUpdate === false)) {
                  _context9.next = 54;
                  break;
                }

                if (!this.role_permission.showWindow) {
                  _context9.next = 50;
                  break;
                }

                userRole = this.userRoles;

                if (!(!userRole || !userRole.length)) {
                  _context9.next = 46;
                  break;
                }

                return _context9.abrupt("return");

              case 46:
                roleBlock = userRole.filter(function (item) {
                  return item.is_default_role;
                });
                user_role_chat = [{
                  user_id: this.form.uid,
                  role_id_block: roleBlock[0].id,
                  is_active: this.role_permission.enablePrivateChat
                }];
                _context9.next = 50;
                return this.$store.dispatch('company/INSERT_USER_ROLE_CHAT_POLICY_MUTATE', user_role_chat).catch(function (error) {
                  _this5.waitDialogVisible = false;

                  _this5.$notify({
                    title: 'エラー',
                    message: '社員情報の編集に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  throw error;
                });

              case 50:
                this.$notify({
                  title: '情報',
                  message: '更新に成功しました。',
                  type: 'success',
                  duration: 2000
                });
                this.waitDialogVisible = false;

                if (!((0, _auth.getToken)() === 'admin-token')) {
                  _context9.next = 54;
                  break;
                }

                return _context9.abrupt("return", this.$router.push({
                  name: 'CompanyIndex'
                }));

              case 54:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function onUpdate() {
        return _onUpdate.apply(this, arguments);
      }

      return onUpdate;
    }(),
    isNumber: function isNumber(val) {
      var regex = new RegExp(/^[0-9]+$/);
      return regex.test(val);
    },
    isHanEisu: function isHanEisu(str) {
      str = str === null ? '' : str;

      if (str.match(/^[A-Za-z0-9]*$/)) {
        return true;
      } else {
        return false;
      }
    },
    log: function log(text) {}
  }
};
exports.default = _default;